export default {
    REQUEST_AUTOMOBILE_MANUFACTURERS: "REQUEST_AUTOMOBILE_MANUFACTURERS",
    REQUEST_AUTOMOBILE_MANUFACTURERS_SUCCESS: "REQUEST_AUTOMOBILE_MANUFACTURERS_SUCCESS",
    REQUEST_AUTOMOBILE_MANUFACTURERS_FAIL: "REQUEST_AUTOMOBILE_MANUFACTURERS_FAIL"
};
